// extracted by mini-css-extract-plugin
export default {"clickable":"_3ouxuSbF9zaaGoTceODnJA","classic":"_29ndmJ06ljCETlNUMLyPcg","primary":"_8prb6iywRn7VwRrpCrYMO"};